// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   ArrowLeft,
//   BookOpen,
//   Clock,
//   Award,
//   MapPin,
//   Users,
//   FileText,
//   Calendar,
// } from "lucide-react";
// import { RiArrowLeftSLine } from "react-icons/ri";
// import axios from "axios";
// import Loader from "../../../common/Loader";

// const CourseDetails = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [course, setCourse] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const courseId = location.state?.courseId;

//   useEffect(() => {
//     if (!courseId) {
//       setError("No course ID provided");
//       setIsLoading(false);
//       return;
//     }

//     const fetchCourseDetails = async () => {
//       try {
//         const config = {
//           method: "get",
//           maxBodyLength: Infinity,
//           url: `${process.env.REACT_APP_API_URL}/courses/get-course-by-id/${courseId}`,
//           headers: {},
//         };
//         const startTime = Date.now();
//         const response = await axios.request(config);
//         const elapsed = Date.now() - startTime;
//         const remaining = Math.max(1000 - elapsed, 0);

//         if (response.data.success) {
//           setCourse(response.data.data);
//         }

//         setTimeout(() => setIsLoading(false), remaining);
//       } catch (err) {
//         console.error("Error fetching course details:", err);
//         setError(err.message);
//         setTimeout(() => setIsLoading(false), 1000);
//       }
//     };

//     fetchCourseDetails();
//   }, [courseId]);

//   if (isLoading) {
//     return (
//       <div className="min-h-screen p-6 dashboardContainer">
//         <Loader />
//       </div>
//     );
//   }

//   if (error || !course) {
//     return (
//       <div className="min-h-screen p-6 dashboardContainer">
//         <div className="text-center py-16">
//           <div className="text-6xl mb-4">⚠️</div>
//           <h3 className="text-2xl font-bold text-primaryTextColor mb-2">
//             {error || "Course not found"}
//           </h3>
//           <button
//             onClick={() => navigate("/courses")}
//             className="mt-4 bg-primaryBtnColor hover:bg-opacity-90 text-white px-6 py-3 rounded-lg"
//           >
//             Back to Courses
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen p-6 dashboardContainer mt-6 mb-4">
//       <div className="w-full mx-auto">
//         <div
//           onClick={() => navigate("/courses")}
//           className="flex items-center gap-1 hover:text-opacity-80 mb-6 transition-all"
//         >
//           <RiArrowLeftSLine size={40} className="cursor-pointer" />
//           <span className="inline-block bg-secondaryColor text-white text-sm font-semibold px-4 py-2 rounded-full uppercase">
//             {course.category}
//           </span>
//         </div>

//         <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-6">
//           {course.img && (
//             <div className="w-full h-64 md:h-80 overflow-hidden">
//               <img
//                 src={course.img}
//                 alt={course.name}
//                 className="w-full h-full object-cover"
//               />
//             </div>
//           )}

//           <div className="p-6 md:p-8">
//             <h1 className="text-3xl md:text-4xl font-bold text-primaryTextColor mb-3">
//               {course.name}
//             </h1>

//             <p className="text-xl text-secondaryColor font-semibold mb-4">
//               {course.instituteName}
//             </p>

//             <p className="text-secondaryTextColor text-base leading-relaxed">
//               {course.description}
//             </p>
//           </div>
//         </div>

//         {/* Course Info Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//           <div className="bg-white rounded-lg shadow-md p-6">
//             <div className="flex items-center gap-3 mb-2">
//               <div className="bg-blue-100 p-3 rounded-full">
//                 <BookOpen className="text-blue-600" size={24} />
//               </div>
//               <h3 className="font-semibold text-primaryTextColor">
//                 Program Type
//               </h3>
//             </div>
//             <p className="text-secondaryTextColor">{course.programType}</p>
//           </div>

//           <div className="bg-white rounded-lg shadow-md p-6">
//             <div className="flex items-center gap-3 mb-2">
//               <div className="bg-green-100 p-3 rounded-full">
//                 <Clock className="text-green-600" size={24} />
//               </div>
//               <h3 className="font-semibold text-primaryTextColor">Duration</h3>
//             </div>
//             <p className="text-secondaryTextColor">{course.duration}</p>
//           </div>

//           <div className="bg-white rounded-lg shadow-md p-6">
//             <div className="flex items-center gap-3 mb-2">
//               <div className="bg-purple-100 p-3 rounded-full">
//                 <Award className="text-purple-600" size={24} />
//               </div>
//               <h3 className="font-semibold text-primaryTextColor">Credits</h3>
//             </div>
//             <p className="text-secondaryTextColor">{course.credits} Credits</p>
//           </div>

//           <div className="bg-white rounded-lg shadow-md p-6">
//             <div className="flex items-center gap-3 mb-2">
//               <div className="bg-orange-100 p-3 rounded-full">
//                 <MapPin className="text-orange-600" size={24} />
//               </div>
//               <h3 className="font-semibold text-primaryTextColor">Location</h3>
//             </div>
//             <p className="text-secondaryTextColor">{course.location}</p>
//           </div>
//         </div>

//         {/* Additional Info */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
//           <div className="bg-white rounded-lg shadow-md p-6">
//             <div className="flex items-center gap-3 mb-4">
//               <Users className="text-primaryColor" size={24} />
//               <h2 className="text-2xl font-bold text-primaryTextColor">
//                 Eligibility
//               </h2>
//             </div>
//             <p className="text-secondaryTextColor text-lg">
//               {course.eligibility}
//             </p>
//           </div>

//           <div className="bg-white rounded-lg shadow-md p-6">
//             <div className="flex items-center gap-3 mb-4">
//               <FileText className="text-primaryColor" size={24} />
//               <h2 className="text-2xl font-bold text-primaryTextColor">
//                 University
//               </h2>
//             </div>
//             <p className="text-secondaryTextColor text-lg">
//               {course.universityCollaboration}
//             </p>
//           </div>
//         </div>

//         {/* Curriculum */}
//         {course.curriculum && course.curriculum.length > 0 && (
//           <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-6">
//             <div className="flex items-center gap-3 mb-6">
//               <Calendar className="text-primaryColor" size={28} />
//               <h2 className="text-2xl md:text-3xl font-bold text-primaryTextColor">
//                 Curriculum
//               </h2>
//             </div>

//             <div className="space-y-6">
//               {course.curriculum.map((item, index) => (
//                 <div
//                   key={item._id || index}
//                   className="border-l-4 border-primaryColor pl-6 py-2"
//                 >
//                   <div className="flex flex-wrap items-center gap-3 mb-4">
//                     <h3 className="text-xl font-bold text-primaryTextColor">
//                       {item.year} - {item.semester}
//                     </h3>
//                     <span className="bg-gray-100 text-primaryTextColor text-sm px-3 py-1 rounded-full">
//                       {item.credits} Credits
//                     </span>
//                   </div>

//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                     {item.subjects.map((subject) => (
//                       <div
//                         key={subject._id}
//                         className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors"
//                       >
//                         <p className="font-semibold text-primaryTextColor mb-1">
//                           {subject.name}
//                         </p>
//                         <span
//                           className={`inline-block text-xs px-2 py-1 rounded-full ${
//                             subject.type === "theory"
//                               ? "bg-blue-100 text-blue-700"
//                               : "bg-green-100 text-green-700"
//                           }`}
//                         >
//                           {subject.type}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Career Paths */}
//         {course.careerPaths && course.careerPaths.length > 0 && (
//           <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
//             <div className="flex items-center gap-3 mb-6">
//               <Award className="text-primaryColor" size={28} />
//               <h2 className="text-2xl md:text-3xl font-bold text-primaryTextColor">
//                 Career Paths
//               </h2>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//               {course.careerPaths.map((career, index) => (
//                 <div
//                   key={index}
//                   className="bg-gradient-to-r from-primaryColor to-secondaryColor text-white rounded-lg p-4 shadow-md hover:shadow-lg transition-all"
//                 >
//                   <p className="font-semibold">{career}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CourseDetails;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  BookOpen,
  Clock,
  Award,
  MapPin,
  Users,
  FileText,
  Calendar,
  ChevronDown,
} from "lucide-react";
import { RiArrowLeftSLine } from "react-icons/ri";
import axios from "axios";
import Loader from "../../../common/Loader";

const CourseDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(0);

  const courseId = location.state?.courseId;

  useEffect(() => {
    if (!courseId) {
      setError("No course ID provided");
      setIsLoading(false);
      return;
    }

    const fetchCourseDetails = async () => {
      try {
        const config = {
          method: "get",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_API_URL}/courses/get-course-by-id/${courseId}`,
          headers: {},
        };
        const startTime = Date.now();
        const response = await axios.request(config);
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(1000 - elapsed, 0);

        if (response.data.success) {
          setCourse(response.data.data);
        }

        setTimeout(() => setIsLoading(false), remaining);
      } catch (err) {
        console.error("Error fetching course details:", err);
        setError(err.message);
        setTimeout(() => setIsLoading(false), 1000);
      }
    };

    fetchCourseDetails();
  }, [courseId]);

  if (isLoading) {
    return (
      <div className="min-h-screen p-6 dashboardContainer">
        <Loader />
      </div>
    );
  }

  if (error || !course) {
    return (
      <div className="min-h-screen p-6 dashboardContainer">
        <div className="text-center py-16">
          <div className="text-6xl mb-4">⚠️</div>
          <h3 className="text-2xl font-bold text-primaryTextColor mb-2">
            {error || "Course not found"}
          </h3>
          <button
            onClick={() => navigate("/courses")}
            className="mt-4 bg-primaryBtnColor hover:bg-opacity-90 text-white px-6 py-3 rounded-lg"
          >
            Back to Courses
          </button>
        </div>
      </div>
    );
  }

  const displayProgram = course.programs && course.programs[selectedProgram];

  return (
    <div className="min-h-screen p-6 dashboardContainer mt-6 mb-4">
      <div className="w-full mx-auto">
        <div
          onClick={() => navigate("/courses")}
          className="flex items-center gap-1 hover:text-opacity-80 mb-6 transition-all"
        >
          <RiArrowLeftSLine size={40} className="cursor-pointer" />
          <span className="inline-block bg-secondaryColor text-white text-sm font-semibold px-4 py-2 rounded-full uppercase">
            {course.category}
          </span>
        </div>

        <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-6">
          {course.img && (
            <div className="w-full h-64 md:h-80 overflow-hidden">
              <img
                src={course.img}
                alt={course.name}
                className="w-full h-full object-cover"
              />
            </div>
          )}

          <div className="p-6 md:p-8">
            <h1 className="text-3xl md:text-4xl font-bold text-primaryTextColor mb-3">
              {course.name}
            </h1>

            <p className="text-xl text-secondaryColor font-semibold mb-4">
              {course.instituteName}
            </p>

            <p className="text-secondaryTextColor text-base leading-relaxed">
              {course.description}
            </p>
          </div>
        </div>

        {/* Program Selector */}
        {course.programs && course.programs.length > 1 && (
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <h2 className="text-xl font-bold text-primaryTextColor mb-4">
              Select Program Type
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {course.programs.map((program, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedProgram(index)}
                  className={`p-4 rounded-lg border-2 transition-all text-left ${
                    selectedProgram === index
                      ? "border-primaryColor bg-blue-50"
                      : "border-gray-200 bg-white hover:border-primaryColor"
                  }`}
                >
                  <p className="font-semibold text-primaryTextColor">
                    {program.programType}
                  </p>
                  <p className="text-sm text-secondaryTextColor">
                    {program.duration} • {program.credits} Credits
                  </p>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Course Info Grid */}
        {displayProgram && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-blue-100 p-3 rounded-full">
                  <BookOpen className="text-blue-600" size={24} />
                </div>
                <h3 className="font-semibold text-primaryTextColor">
                  Program Type
                </h3>
              </div>
              <p className="text-secondaryTextColor">
                {displayProgram.programType}
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-green-100 p-3 rounded-full">
                  <Clock className="text-green-600" size={24} />
                </div>
                <h3 className="font-semibold text-primaryTextColor">
                  Duration
                </h3>
              </div>
              <p className="text-secondaryTextColor">
                {displayProgram.duration}
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-purple-100 p-3 rounded-full">
                  <Award className="text-purple-600" size={24} />
                </div>
                <h3 className="font-semibold text-primaryTextColor">Credits</h3>
              </div>
              <p className="text-secondaryTextColor">
                {displayProgram.credits} Credits
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-orange-100 p-3 rounded-full">
                  <MapPin className="text-orange-600" size={24} />
                </div>
                <h3 className="font-semibold text-primaryTextColor">
                  Location
                </h3>
              </div>
              <p className="text-secondaryTextColor">{course.location}</p>
            </div>
          </div>
        )}

        {/* Additional Info */}
        {displayProgram && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center gap-3 mb-4">
                <Users className="text-primaryColor" size={24} />
                <h2 className="text-2xl font-bold text-primaryTextColor">
                  Eligibility
                </h2>
              </div>
              <p className="text-secondaryTextColor text-lg">
                {displayProgram.eligibility}
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center gap-3 mb-4">
                <FileText className="text-primaryColor" size={24} />
                <h2 className="text-2xl font-bold text-primaryTextColor">
                  Application Fee
                </h2>
              </div>
              <p className="text-secondaryTextColor text-lg">
                ₹{displayProgram.onlineApplicationFee.toLocaleString()}
              </p>
            </div>
          </div>
        )}

        {/* University Collaboration */}
        {course.universityCollaboration && (
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <div className="flex items-center gap-3 mb-4">
              <Award className="text-primaryColor" size={24} />
              <h2 className="text-2xl font-bold text-primaryTextColor">
                University Collaboration
              </h2>
            </div>
            <p className="text-secondaryTextColor text-lg">
              {course.universityCollaboration}
            </p>
          </div>
        )}

        {/* Curriculum */}
        {displayProgram?.curriculum && displayProgram.curriculum.length > 0 && (
          <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-6">
            <div className="flex items-center gap-3 mb-6">
              <Calendar className="text-primaryColor" size={28} />
              <h2 className="text-2xl md:text-3xl font-bold text-primaryTextColor">
                Curriculum
              </h2>
            </div>

            <div className="space-y-6">
              {displayProgram.curriculum.map((item, index) => (
                <div
                  key={item._id || index}
                  className="border-l-4 border-primaryColor pl-6 py-2"
                >
                  <div className="flex flex-wrap items-center gap-3 mb-4">
                    <h3 className="text-xl font-bold text-primaryTextColor">
                      {item.year} - {item.semester}
                    </h3>
                    <span className="bg-gray-100 text-primaryTextColor text-sm px-3 py-1 rounded-full">
                      {item.credits} Credits
                    </span>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {item.subjects.map((subject) => (
                      <div
                        key={subject._id}
                        className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors"
                      >
                        <p className="font-semibold text-primaryTextColor mb-1">
                          {subject.name}
                        </p>
                        <span
                          className={`inline-block text-xs px-2 py-1 rounded-full ${
                            subject.type === "theory"
                              ? "bg-blue-100 text-blue-700"
                              : "bg-green-100 text-green-700"
                          }`}
                        >
                          {subject.type}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Career Paths */}
        {course.careerPaths && course.careerPaths.length > 0 && (
          <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <Award className="text-primaryColor" size={28} />
              <h2 className="text-2xl md:text-3xl font-bold text-primaryTextColor">
                Career Paths
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {course.careerPaths.map((career, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-r from-primaryColor to-secondaryColor text-white rounded-lg p-4 shadow-md hover:shadow-lg transition-all"
                >
                  <p className="font-semibold">{career}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseDetails;
